import React from 'react';
import OldBillDetails from './lis-old-bill-details';
import NewBillDetails from './lis-new-bill-details';

class PublicBillDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ marginTop: "-15px" }}>
                {this.props.match.params.sessionCode <= 20251
                    ? <OldBillDetails
                        params={this.props.match.params}
                        location={this.props.location}
                        history={this.props.history}
                    />
                    : <NewBillDetails
                        params={this.props.match.params}
                        location={this.props.location}
                        history={this.props.history}
                    />
                }
            </div>
        )
    }
}

export default PublicBillDetails;